import { Button, Description, Guide } from '@zenterprise-inc/ui';
import { FC } from 'react';

import IllustProgram from '@/assets/illust-icons/fill-p-program.svg';

interface Props {
  handleDownload: () => void;
  handleClick: () => void;
}
type ProgramDownloadCompleteGuideProps = Props;

const ProgramDownloadCompleteGuide: FC<ProgramDownloadCompleteGuideProps> = ({ handleDownload, handleClick }) => {
  return (
    <>
      <Guide>
        <Guide.ImageArea>
          <IllustProgram width={80} height={80} />
        </Guide.ImageArea>
        <Guide.TextArea>
          <Guide.Description>
            <div className="text-16">
              프로그램 설치를 완료한 후<br />
              다음 단계를 진행해주세요
            </div>
          </Guide.Description>
        </Guide.TextArea>
      </Guide>

      <div className="pb-5" />

      <Description.Section
        text={
          <div className="flex justify-center items-center max-w-[520px]">
            <span className="mr-[10px] body-14 text-gray-700">다운로드가 완료되지 않았나요?</span>
            <Button.Box state={'secondary'} size={'small'} onClick={handleDownload}>
              프로그램 다운로드
            </Button.Box>
          </div>
        }
        bgType={'BgTransparent'}
      />

      <Button.StickyBottom.Wrapper className="page-padding">
        <Button.StickyBottom.Button state="primary" onClick={handleClick}>
          설치를 완료했어요
        </Button.StickyBottom.Button>
      </Button.StickyBottom.Wrapper>
    </>
  );
};

export default ProgramDownloadCompleteGuide;
